import LayerSectionBase from './LayerSectionBase.js';

export default class LayerSection extends LayerSectionBase {
  constructor(imageDataManager, selection, getSelectedFrameIdx, requestDraw, doChange) {
    super(document.querySelector('#layerSection'), selection, requestDraw, {
      'New': {
        execute: () => this._do('add-layer', this._getSelectedFrameIdx(), this.getDisplayIdxSelected(), 1), 
        check: () => this._getDisplaySzSelected() <= 1,
      },
      'Duplicate': {
        execute: () => this._do('duplicate-layer', this._getSelectedFrameIdx(), ...this._getDisplayIdxSzSelected()),
        check: () => this._getDisplaySzSelected() >= 1,
      },
      'Delete': {
        execute: () => this._do('delete-layer', this._getSelectedFrameIdx(), ...this._getDisplayIdxSzSelected()),
        check: () => this._getDisplaySzSelected() >= 1,
      },
      'Merge': {
        execute: () => this._do('merge-layer', this._getSelectedFrameIdx(), ...this._getDisplayIdxSzSelected()),
        check: () => this._getDisplaySzSelected() >= 2,
      },
    });
    this._imageDataManager = imageDataManager;
    this._getSelectedFrameIdx = getSelectedFrameIdx;
    this._do = doChange;
    this._setResizeObserverX(x => {
      const elFrameSection = document.querySelector('#frameSection');
      elFrameSection.style.right = `calc(${window.innerWidth - x}px + 1vh)`;
    });
  }
  _selectInnerData(idx) {
    this._imageDataManager.selectLayer(idx);
  }
  _drawThumbnail(canvas, idx) {
    this._imageDataManager.drawLayerThumbnail(canvas, idx);
  }
  _doMove(srcIdx, srcSz, dstIdx) {
    const frameIdx = this._getSelectedFrameIdx();
    this._do('move-layer', frameIdx, srcIdx, srcSz, dstIdx);
  }
  add(idx, sz, show = true) {
    this._addDisplays(idx, sz, show);
    this._imageDataManager.addLayer(idx, sz);
  }
  insert(idx, ...targets) {
    this._addDisplays(idx, targets.length);
    this._imageDataManager.insertLayer(idx, ...targets)
  }
  duplicate(idx, sz) {
    this._addDisplays(idx, sz);
    this._imageDataManager.duplicateLayer(idx, sz);
    this._updateThumbnails(idx, sz);
  }
  delete(idx, sz) {
    this._deleteDisplays(idx, sz);
    return this._imageDataManager.deleteLayer(idx, sz);
  }
  merge(idx, sz) {
    this._addDisplays(idx, 1);
    this._deleteDisplays(idx + 1, sz);
    return this._imageDataManager.mergeLayer(idx, sz);
  }
  move(srcIdx, srcSz, dstIdx) {
    this._imageDataManager.moveLayer(srcIdx, srcSz, dstIdx);
    this._moveDisplays(srcIdx, srcSz, dstIdx);
  }
}
